import React, { useEffect, useRef, useState } from 'react';
import { useParams } from "react-router-dom";
//api
import { TravelUrbanAPI } from '../../../../../api/travel_urban/travelUrbanAPI';
import { TravelUrbanRel } from '../../../../../api/travel_urban/travelUrbanModel';
//components
import SharingTravelPassengerType1 from "../_components/TravelUrbanSharingPanelPassengerType1";
import TravelUrbanSharingPanelPassengerType2 from "../_components/TravelUrbanSharingPanelPassengerType2";
import TravelUrbanSharingMarkerPointA from "../_components/TravelUrbanSharingMarkerPointA";
import TravelUrbanSharingMarkerPointB from "../_components/TravelUrbanSharingMarkerPointB";
import TravelUrbanSharingMarkerDriver from "../_components/TravelUrbanSharingMarkerDriver";
import TravelUrbanSharingPanelDriverType1 from "../_components/TravelUrbanSharingPanelDriverType1";
import TravelUrbanSharingPanelDriverType2 from "../_components/TravelUrbanSharingPanelDriverType2";
//types
import { Coordinates, TravelUrbanStackParamsList } from "../types";
//libs
import config from '../../../../../config';
import { useJsApiLoader } from '@react-google-maps/api';
import GoogleMapsCMP, { libraries } from '../../../../_components/GoogleMaps';
const logo = require("../../../../../assets/img/logo.png").default;

const TravelUrbanSharing = () => {
    const params = useParams<TravelUrbanStackParamsList["TravelUrbanSharing"]>();
    const wsRef = useRef<WebSocket | null>(null);
    const iSync = useRef<NodeJS.Timeout | number>(0);

    const [travel_urban, setTravelUrban] = useState<TravelUrbanRel>({});
    const [type1, setType1] = useState(false);
    const [type2, setType2] = useState(false);
    const [origin, setOrigin] = useState<Coordinates>({ lat: 0, lng: 0 });
    const [destiny, setDestiny] = useState<Coordinates>({ lat: 0, lng: 0 });
    const [isTravelNull, setIsTravelNull] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isMapToOrigin, setIsMapToOrigin] = useState(false);
    const [isMapToDestiny, setIsMapToDestiny] = useState(false);

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: config.googleAPIKey,
        libraries: libraries,
    });

    useEffect(() => {
        const { code, type } = params;
        if (!code) return;

        iSync.current = setInterval(async () => {
            await getTravelByCode(String(code), String(type));
        }, 3000);

        // primero consulta API para traer info del viaje
        getTravelByCode(code, type ?? "1")

        return () => {
            clearInterval(iSync.current as NodeJS.Timeout);
            if (wsRef.current) {
                wsRef.current.close();
                wsRef.current = null;
            }
        };
    }, []);


    const getTravelByCode = async (code: string, type: string) => {

        return await TravelUrbanAPI.getByCode(String(code)).then(res => {
            if (res.code === 200) {
                const tu = res.travel_urban;
                setTravelUrban(tu);

                // setea tipo de vista
                if (type === "1") { setType1(true); setType2(false); }
                else { setType1(false); setType2(true); }

                // origen y destino inicial
                if (tu.travel_urban_status_id === 2) {
                    setOrigin({ lat: tu.user_driver?.lat, lng: tu.user_driver?.lng });
                    setDestiny({ lat: tu.ori_lat, lng: tu.ori_lng });
                    setIsMapToOrigin(true);
                } else if (tu.travel_urban_status_id === 3) {
                    setOrigin({ lat: tu.user_driver?.lat, lng: tu.user_driver?.lng });
                    setDestiny({ lat: tu.desti_lat, lng: tu.desti_lng });
                    setIsMapToDestiny(true);
                }

                // abrir socket para actualizaciones en tiempo real
                // connectWebSocket(tu.user_driver?.id);
            } else {
                setIsTravelNull(true);
            }
            setIsLoading(false);
        });
    }

    // const connectWebSocket = (driverId?: number) => {
    //     if (!driverId) return;

    //     const url = (process.env.NODE_ENV === "development")
    //         ? "ws://192.168.100.104:3045"
    //         : "wss://movilexpresscompe.com";

    //     const ws = new WebSocket(url);
    //     wsRef.current = ws;

    //     ws.onopen = () => {
    //         console.log("[WS] Conectado");
    //         ws.send(JSON.stringify({ type: "subscribe", channel: driverId }));
    //     };

    //     ws.onmessage = async (event) => {
    //         try {
    //             let rawData: string;

    //             if (event.data instanceof Blob) {
    //                 // convierte el Blob en texto
    //                 rawData = await event.data.text();
    //             } else {
    //                 rawData = event.data; // ya es string
    //             }

    //             const data = JSON.parse(rawData);
    //             console.log("[WS] Mensaje recibido", data);
    //             if (data.type === "locationUpdate") {
    //                 const payload = data.payload;
    //                 console.log("[WS] locationUpdate:", payload);

    //                 setTravelUrban(prev => ({
    //                     ...prev,
    //                     user_driver: {
    //                         ...(prev.user_driver || {}),
    //                         lat: payload.lat,
    //                         lng: payload.lng,
    //                         bearing: payload.heading,
    //                     },
    //                 }));

    //                 // mover marker del conductor
    //                 setOrigin({ lat: payload.lat, lng: payload.lng });
    //             }
    //         } catch (e) {
    //             console.error("[WS] error parse:", e);
    //         }
    //     };

    //     ws.onclose = () => {
    //         console.log("[WS] cerrado, reintentando en 5s");
    //         setTimeout(() => connectWebSocket(driverId), 5000);
    //     };

    //     ws.onerror = (err) => {
    //         console.error("[WS] error:", err);
    //         ws.close();
    //     };
    // };

    return (
        <div style={{ width: '100vw', height: '100vh', backgroundColor: '#fff' }}>
            {/* paneles */}
            {type1 && isMapToOrigin && <SharingTravelPassengerType1 travel_urban={travel_urban} />}
            {type1 && isMapToDestiny && <TravelUrbanSharingPanelPassengerType2 travel_urban={travel_urban} />}
            {type2 && isMapToOrigin && <TravelUrbanSharingPanelDriverType1 travel_urban={travel_urban} />}
            {type2 && isMapToDestiny && <TravelUrbanSharingPanelDriverType2 travel_urban={travel_urban} />}

            {/* mapa */}
            <div style={{ width: '100vw', height: "100vh" }}>
                {isLoaded && <GoogleMapsCMP
                    bounds={travel_urban && isMapToOrigin ? [
                        {
                            lat: travel_urban.ori_lat ?? 0,
                            lng: travel_urban.ori_lng ?? 0
                        },
                        {
                            lat: travel_urban.user_driver?.lat ?? 0,
                            lng: travel_urban.user_driver?.lng ?? 0
                        }
                    ] : travel_urban && isMapToDestiny ? [
                        {
                            lat: travel_urban.desti_lat ?? 0,
                            lng: travel_urban.desti_lng ?? 0
                        },
                        {
                            lat: travel_urban.user_driver?.lat ?? 0,
                            lng: travel_urban.user_driver?.lng ?? 0
                        }
                    ] : [
                        {
                            lat: travel_urban.ori_lat ?? 0,
                            lng: travel_urban.ori_lng ?? 0
                        },
                        {
                            lat: travel_urban.desti_lat ?? 0,
                            lng: travel_urban.desti_lng ?? 0
                        },
                        {
                            lat: travel_urban.user_driver?.lat ?? 0,
                            lng: travel_urban.user_driver?.lng ?? 0
                        }
                    ]}
                >
                    {travel_urban && isMapToOrigin && <TravelUrbanSharingMarkerPointA lat={travel_urban.ori_lat} lng={travel_urban.ori_lng} />}
                    {travel_urban && isMapToDestiny && <TravelUrbanSharingMarkerPointB lat={travel_urban.desti_lat} lng={travel_urban.desti_lng} />}
                    {travel_urban && travel_urban.user_driver && <TravelUrbanSharingMarkerDriver
                        lat={travel_urban.user_driver?.lat ?? 0} lng={travel_urban.user_driver?.lng ?? 0}
                        travel_urban={travel_urban}
                    />}
                </GoogleMapsCMP>}
            </div>

            {/* estados */}
            {isLoading && <div style={{
                backgroundColor: 'rgba(0,0,0,0.5)',
                position: 'absolute', top: 0, left: 0,
                width: '100vw', height: '100vh',
                display: 'flex', justifyContent: 'center', alignItems: 'center'
            }}>
                <img style={{ width: '10rem' }} src={logo} alt="" />
            </div>}

            {isTravelNull && <div style={{
                backgroundColor: 'rgba(0,0,0,0.6)',
                position: 'absolute', top: 0, left: 0,
                width: '100vw', height: '100vh',
                display: 'flex', justifyContent: 'center', alignItems: 'center'
            }}>
                <div style={{
                    backgroundColor: '#eee', padding: 20, paddingTop: 40,
                    display: 'flex', justifyContent: 'center', flexDirection: 'column',
                    alignItems: 'center', borderRadius: 20
                }}>
                    <img style={{ width: '10rem', marginBottom: 15 }} src={logo} alt="" />
                    <h3>No Disponible</h3>
                    <h6>El viaje ya no se encuentra disponible</h6>
                </div>
            </div>}

            {/* logo */}
            <img style={{
                position: "absolute", zIndex: 1000, bottom: 20, right: 20,
                width: '3.5rem', opacity: .9
            }} src={logo} alt="" />
        </div>
    );
};

export default TravelUrbanSharing;